import React, { ComponentProps, PropsWithChildren } from 'react';
import { ContentWrapper } from '../../../components/blocks/ContentWrapper/ContentWrapper';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { CollapsibleBlock, CollapsibleBlockModifier } from '../../../components/molecules/CollapsibleBlock';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useContentWrapperContext } from '../../../components/blocks/ContentWrapper/ContentWrapperContext';
import { useGlobalPrintMode } from '../../../contexts/GlobalPrintMode';
import { asFetchableView } from '../../../_lib/ViewFetcher';

type CollapsibleContainerBlockDefaultProps = PropsWithChildren<any>;

export function CollapsibleContainerBlockDefault({ views }: CollapsibleContainerBlockDefaultProps) {
  const { t } = useSonTranslation('CollapsibleContainerBlock');
  const { uuid } = useBlockContext();
  const { editModeInfo } = useAppContext();
  const contentWrapperContext = useContentWrapperContext();
  const { isInGlobalPrintMode } = useGlobalPrintMode();

  return (
    <CollapsibleBlock
      title={views.default?.embedded?.title || t('default.heading')}
      closed={!(isInGlobalPrintMode || editModeInfo.active)}
      modifier={editModeInfo.active ? CollapsibleBlockModifier.EDITMODE : undefined}
      id={uuid}
      key={uuid}
    >
      <ContentWrapper
        views={views}
        fetchUrl={views.default.fetchUrl}
        collapsibleParentUuid={uuid}
        moveOutsideOfCollapsibleBlock={contentWrapperContext?.moveOutsideOfCollapsibleBlock}
        // the current block's index is the parentIndex for the encapsulated contentWrapper
        parentIndex={contentWrapperContext?.index}
        registerStateHandler={contentWrapperContext?.registerCollapsibleStateHandlerCallback}
        onCollapsibleBlockContentWrapperChange={contentWrapperContext?.onCollapsibleBlockContentWrapperChange}
      />
    </CollapsibleBlock>
  );
}

export const CollapsibleContainerBlockDefaultView = asFetchableView(CollapsibleContainerBlockDefault);
export type CollapsibleContainerBlockDefaultView = ComponentProps<typeof CollapsibleContainerBlockDefault>;
